import React, { useEffect, useState } from 'react';
import { Col, Form, InputGroup, Toast } from 'react-bootstrap';
import { getLocationByCityName } from '../../Redux/Action/LocationAction';
import { REDUX_CONSTANTS } from '../../Redux/reduxConstants';
import { useDispatch, useSelector } from 'react-redux';
import FullScreenModal from '../FullScreenModal/FullScreenModal';

const initialFields = {
    search: ''
};

function SearchComponent() {

    const dispatch = useDispatch();

    const [fields, setFields] = useState(initialFields);
    const [showMapsModal, setShowMapsModal] = useState(false);

    const alertMessageState = useSelector(state => state.AlertMessageReducer);

    const locationDetails = useSelector(state => state.locationReducer);

    const toggleShow = () => {
        dispatch({ type: REDUX_CONSTANTS.UPDATE_TOAST, payload: false });
    };
    const handleChange = (e) => {
        console.log("🚀 ~ handleChange ~ e:", e);
        setFields(pre => ({ ...pre, [e.target.name]: e.target.value }));
    };

    const onGetLocation = (e) => {
        e.preventDefault();
        dispatch(getLocationByCityName(fields.search));
    };



    useEffect(() => {
        let interval = setTimeout(() => {

            let filteredData = locationDetails.citiesList.filter(item => item.label.toLowerCase().includes(fields.search.toLowerCase()));
            dispatch({
                type: "FILTER_CITIES_LIST",
                payload: filteredData
            });
        }, 3000);

        return () => clearInterval(interval);
    }, [fields.search]);
    return (
        <>
            <FullScreenModal show={showMapsModal} setShow={() => setShowMapsModal(false)} />
            <Col md={6} className="mb-2" style={{ position: 'fixed', zIndex: 100000, left: '50%', top: "30px" }}>
                <Toast show={alertMessageState.showToast} onClose={toggleShow}>
                    <Toast.Header>
                        <img
                            src="holder.js/20x20?text=%20"
                            className="rounded me-2"
                            alt=""
                        />
                        <strong className="me-auto">Sorry</strong>
                        <small>just now</small>
                    </Toast.Header>
                    <Toast.Body>Oops, no city found with entered text!</Toast.Body>
                </Toast>
            </Col>
            <Form type="submit" onSubmit={onGetLocation}>
                {/* <Form.Group className='mt-3 mb-3 d-flex align-items-center'>
                    <Form.Control autoComplete='off' className="" size="md" type="search" name={"search"} value={fields.search} onChange={handleChange} placeholder='Search Location' />
                    <button className='btn btn-outline-primary'>
                        <i className="fa-solid fa-magnifying-glass"></i>

                    </button>
                </Form.Group> */}
                <InputGroup>
                    <InputGroup.Text id="basic-addon1" onClick={()  => setShowMapsModal(true)}><i className='fa-solid fa-location-dot'></i></InputGroup.Text>
                    <Form.Control autoComplete='off' className="" size="md" type="search" name={"search"} value={fields.search} onChange={handleChange} placeholder='Search Location' />

                    <button className='btn btn-outline-primary'>
                        <i className="fa-solid fa-magnifying-glass"></i>

                    </button>
                </InputGroup>
            </Form>
        </>
    );
}

export default SearchComponent;